import './scripts/sub-massenmailer.js';
import './scripts/write-std-dok.js';